import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';
import CrewMembersList from '../components/rts/CrewMembers/CrewMembersList';
import CrewMembersHeader from '../components/rts/CrewMembers/CrewMembersHeader';
import CrewMembersFilter from '../components/rts/CrewMembers/CrewMembersFilter';

import { useSessionContext } from '../contexts/SessionContext';

export default function CrewMembersPage( props ){
    //console.debug("RTS Break CrewMembersPage");

    const {curFilter, user, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [filter, setFilter] = useState();   
    const [data, setData] = useState([]);


    const fetchData = useCallback((pFilter) => {
        let apiURL = apiRoot + "/AppUsers/GetCrewMembersSummary";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
            }
            setIsLoading(false);
            setHasError(false);
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status == 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token]);
 

    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'CrewMembersPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({user:user, customer:sessionCustomer.customer, company:null, markAccess:-1, sortBy:0});
            fetchData({user:user, customer:sessionCustomer.customer, company:null, markAccess:-1, sortBy:0})
        }
    }, [user, sessionCustomer, curFilter, fetchData]); 

 
    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };


    return(
        <Box>
            <CrewMembersHeader />
            <CrewMembersFilter filter={filter} setFilterFx={setFilter}/>
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <CrewMembersList data={data} />
            </Box>
        </Box>
    );
}
